import React from 'react';
import styled from '../../styled';
import Text from '../text';
import { getTranslation } from '../../utils';
import TabItem from './TabItem';
import TabIcon from './TabIcon';
import { MultiLineTextContainer } from './TextContainer';
const TabIconWrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 0.06rem 0.5rem 0.06rem 0;
`;
const FlexItem = styled.div `
  display: flex;
  padding: 0.5rem 0;
`;
const Tab = ({ id, e2eId, activedTabKey, lang = 'zh-hant', subs = [], icon, iconType, renderRightIcon, titleTranslations, subTitleTranslations, bgColor = 'INK_800', bgActiveColor = 'INK_700', bgHoverColor = 'INK_700', hoverColor, iconHoverColor, }) => (React.createElement(TabItem, { "data-e2e-id": e2eId, bgColor: bgColor, bgActiveColor: bgActiveColor, bgHoverColor: bgHoverColor, hoverColor: hoverColor, iconHoverColor: iconHoverColor, isActived: activedTabKey === id ||
        subs.some(({ key: subTabKey }) => activedTabKey === subTabKey) },
    React.createElement(FlexItem, null,
        icon && (React.createElement(TabIconWrapper, null,
            React.createElement(TabIcon, { icon: icon, iconType: iconType }))),
        React.createElement(MultiLineTextContainer, null,
            React.createElement(Text, { fontType: "Body", lang: lang, color: "INK_600", weight: "Medium" }, titleTranslations && getTranslation(titleTranslations, lang)),
            React.createElement(Text, { fontType: "Micro", lang: lang, color: "INK_500" }, subTitleTranslations && getTranslation(subTitleTranslations, lang)))),
    renderRightIcon && renderRightIcon()));
export default Tab;
//# sourceMappingURL=DropdownTabItem.js.map